import React from 'react';
import { TExternalComponentProps } from '../@shared/sharedExternalComponent/types/externalComponent.types';
import SharedExternalComponent from '../@shared/sharedExternalComponent';

const ExternalComponent = (props: TExternalComponentProps) => {
  return <SharedExternalComponent {...props} />
};

export default ExternalComponent;
